import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Fetch from "./../../common/utils/Fetch";
import MultiInputBaseWrapper, { IItemData } from "../../common/controls/MultiInputBaseWrapper";
const $ = (window as any).$;

interface IProps {
	input: HTMLInputElement,
}

interface IState {
	items?: IItemData[],
}

interface IDictionaryItem {
	id: string,
	name: string,
};

interface ISelectedDictionaryItem {
	id: string,
	dictionaryItemId: string,
	name: string,
};

class DictionaryMultiItems extends React.Component<IProps, IState> {

	constructor(props) {
		super(props);

		this.multiInput = React.createRef();

		this.state = {};
	}

	multiInput: React.RefObject<any>;

	componentDidMount() {

		var valueJson: string = this.props.input.value;
		if (valueJson) {
			var values = this.valueToTable(valueJson);

			for (let i = 0; i < values.length; i++) {
				this.multiInput.current.addSelect({
					id: values[i].id,
					label: values[i].name,
				})
			}
		}

		Fetch.get<any>("/IssueDictionaries/GetDictonary", {
			issueId: this.getIssueId(),
			dictionaryName: this.getDictionaryName(),
			field: this.getField(),
		})
			.then(data => {
				this.setState({
					items: this.parseItems(data.items || []).sort((a, b) => {
						return a.label.localeCompare(b.label);
					}),
				});
				
				if (!valueJson) {

					let selected: ISelectedDictionaryItem[] = data.selected || [];

					for (let i = 0; i < selected.length; i++) {
						this.multiInput.current.addSelect({
							id: selected[i].dictionaryItemId,
							label: selected[i].name,
						})
					}
				}
			});
	}

	valueToTable(value: string): IDictionaryItem[] {
		if (!value) {
			return [];
		}

		var tableResult = JSON.parse(value);

		return tableResult;
	}

	parseItems(data: IDictionaryItem[]): IItemData[] {
		var result: IItemData[] = [];
		for (let i = 0; i < data.length; i++) {
			result.push({
				id: data[i].id,
				label: data[i].name, 
			});
		}
		return result;
	}

	parseData(data: IItemData[]): IDictionaryItem[] {
		var result: IDictionaryItem[] = [];
		for (let i = 0; i < data.length; i++) {
			result.push({
				id: data[i].id,
				name: data[i].label,
			});
		}
		return result;
	}

	getIssueId() {
		return this.props.input.dataset.issueid;
	}

	getField() {
		return this.props.input.dataset.field;
	}

	getDictionaryName() {
		return this.props.input.dataset.dictionaryname;
	}

	handleOnChange() {
		let values: IItemData[] = this.multiInput.current.getValue();
		this.props.input.value = JSON.stringify(this.parseData(values));
	}

	render() {
		
		return <div>
			<MultiInputBaseWrapper
				ref={this.multiInput}
				onChange={this.handleOnChange.bind(this)}
				data={this.state.items}
				load={(term: string, cb) => {
					var t = term.toLowerCase();
					let r = this.state.items.filter(x => x.label.toLowerCase().indexOf(t) >= 0 );
					cb(r);
				}}
			/>
		</div>
	}
}

interface IDisplayProps {
	issueId: string,
	field: string,
}

interface IDisplayState {
	selected?: ISelectedDictionaryItem[]
}

class DictionaryMultiItemsDisplay extends React.Component<IDisplayProps, IDisplayState> {

	constructor(props) {
		super(props);
		this.state = {
			selected: [],
		};
	}

	componentDidMount() {
		Fetch.get<any>("/IssueDictionaries/GetDictonary", {
			issueId: this.props.issueId,
			field: this.props.field,
		})
			.then(data => {
				this.setState({
					selected: data.selected || [],
				});
			});
	}

	render() {

		return <div>
			{this.state.selected.map(x =>
				<div key={x.id} data-id={x.dictionaryItemId}>{x.name}</div>
			)}
		</div>
	}
}

function initSelectCombobox(inputElement: HTMLInputElement) {
	$(inputElement).hide().addClass("react-working");
	var newDiv = document.createElement('div');
	inputElement.parentNode.insertBefore(newDiv, inputElement.nextSibling);
	ReactDOM.render(<DictionaryMultiItems
		input={inputElement}
	/>, newDiv);
}

function initDisplayCombobox(displayElement: HTMLElement) {
	$(displayElement).addClass("react-working");
	ReactDOM.render(<DictionaryMultiItemsDisplay issueId={displayElement.dataset.issueid} field={displayElement.dataset.field} />, displayElement);
}

export default {
	initSelectCombobox: initSelectCombobox,
	reload: (rootElement?: HTMLElement) => {
		let inputs = (rootElement || document).querySelectorAll("input.react-multi-dictionary-control:not(.react-working)");
		if (inputs.length != 0) {
			for (let i = 0; i < inputs.length; i++) {
				let select = inputs[i] as HTMLInputElement;
				initSelectCombobox(select);
			}
		}
		let displays = (rootElement || document).querySelectorAll(".react-multi-dictionary-display:not(.react-working)");
		if (displays.length != 0) {
			for (let i = 0; i < displays.length; i++) {
				let display = displays[i] as HTMLElement;
				initDisplayCombobox(display);
			}
		}
	}
} 